import React, { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import Apis from '../../api';
import MessageActions from '../message/redux/actions';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../routes/RoutesURL';

const AccountActivation: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    useLayoutEffect(() => {
        if (token) {
            Apis.activateAccount({
                token,
            })
                .then(() => {
                    dispatch(
                        MessageActions.showMessage({
                            error: false,
                            text: 'Account activated successfully. Please login',
                        }),
                    );
                    if (window.location && window.location.pathname === HEADERMENU_PATH.activateAccountAndSetPassword) {
                        navigate(`${HEADERMENU_PATH.resetPassword}?token=${token}`);
                    } else {
                        navigate(`/login`);
                    }
                })
                .catch(() => {
                    dispatch(
                        MessageActions.showMessage({
                            error: true,
                            text: 'This activation link has already expired. Please login to your account to resend activation email.',
                        }),
                    );
                    navigate(`/login`);
                });
        } else {
            navigate(`/login`);
        }
    }, [token, dispatch, navigate]);

    return (
        <div className="flex justify-center items-center pt-24">
            <div
                style={{ borderTopColor: 'transparent' }}
                className="w-40 h-40 border-8 border-blue-500 border-solid rounded-full animate-spin"
            />
        </div>
    );
};

export default AccountActivation;
